import "./public-path";
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import isViewButton from "./utils/menu/ViewButton"; //查看列表页面增删改查
import checkPermission from "./utils/menu/checkPermission"; //查看列表页面增删改查
import dateFormat from "./utils/menu/dateFormat"; //时间处理Y + M + D + h + m + s;
import dateFormatDay from "./utils/menu/dateFormatDay"; //时间处理Y + M + D;
import { isQiankun } from './utils/utils'

import './assets/css/element-variables.scss'
import ElementUI from "element-ui";
import "./assets/css/icon.css";
import "./assets/css/main.css";
import "./assets/css/color-dark.css"; /*深色主题*/

import store from "./store";

import VueAxios from "vue-axios";
import axios from "./utils/request";

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "babel-polyfill";
import moment from "moment";
Vue.use(VueQuillEditor);
import AMap from "vue-amap";
Vue.use(AMap);
import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";
Vue.use(VueAxios, axios);
Vue.use(Avue, { axios });
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.$isViewButton = isViewButton;
Vue.prototype.$checkPermission = checkPermission;
Vue.prototype.$dateFormat = dateFormat;
Vue.prototype.$dateFormatDay = dateFormatDay;
Vue.prototype.$isQiankun = isQiankun();

Vue.config.devtools = true; //生产环境中需要设置为false
Vue.config.productionTip = false; //阻止vue启动时生成生产消息
Vue.config.silent = true; //静默(取消)日志与警告提醒
// 注册element-ui
Vue.use(ElementUI);

// 全局防抖
// 防抖处理-立即执行
const on = Vue.prototype.$on;
Vue.prototype.$on = function(event, func) {
  let timer;
  let flag = true;
  let newFunc = func;
  if (event == "click") {
    newFunc = function() {
      if (flag) {
        func.apply(this, arguments);
        flag = false;
      }
      clearTimeout(timer);
      timer = setTimeout(function() {
        flag = true;
      }, 1000);
    };
  }
  on.call(this, event, newFunc);
};

/* eslint-disable no-new */
// var app = new Vue({
//   el: '#app',
//   store,
//   router,
//   render: (h) => h(App),
// })

/**
 * 配置qiankun
 */
let instance = null;

function render(props = {}) {
  const { container } = props;
  instance = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount(container ? container.querySelector("#app") : "#app");
}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props) {
  Vue.prototype.$ReLogin = props.data.reLogin;
  Vue.prototype.$token = props.data.token;
  Vue.prototype.$pRouter = props.data.router;
  render(props);
}
/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  console.log("%c", "color:green;", " ChildOne bootstrap");
}
export async function update() {
  console.log("%c", "color:green;", " ChildOne update");
}
/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount(props) {
  console.log("unmount", props);
  instance.$destroy();
  instance.$el.innerHTML = "";
  instance = null;
}

if (!window.__POWERED_BY_QIANKUN__) {
  render();
}
